module.exports = "/_next/static/media/ed3a2b1fe3bd0af07d0bfc004e95b484.svg";